export const RETURNING_USER_TITLE = 'We found a previously added pup!';

export const RETURNING_USER_MESSAGE =
  'If you want to remove the profile, please click remove before you continue.';

export const RETURNING_USER_CONTINUE_BUTTON = 'Continue';

export const RETURNING_USER_ARIA_LABEL = 'Cart Consolidation Modal';
